export enum actionTypes {
  CHANGE_PASSWORD_FETCH = 'CHANGE_PASSWORD_FETCH',
  CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS',
  CHANGE_PASSWORD_EXPIRED_TOKEN = 'CHANGE_PASSWORD_EXPIRED_TOKEN',
  CHANGE_PASSWORD_ERROR = 'CHANGE_PASSWORD_ERROR',
  CHANGE_PASSWORD_RESET = 'CHANGE_PASSWORD_RESET',
  CHECK_TOKEN_FETCH = 'CHECK_TOKEN_FETCH',
  CHECK_TOKEN_SUCCESS = 'CHECK_TOKEN_SUCCESS',
  CHECK_TOKEN_ERROR = 'CHECK_TOKEN_ERROR',
  CHECK_TOKEN_RESET = 'CHECK_TOKEN_RESET',
}

export enum CheckTokenStatus {
  Idle,
  Loading,
  Error,
  ExpiredToken,
  Success,
}

export enum ChangePasswordStatus {
  Idle,
  Loading,
  Error,
  ExpiredToken,
  Success,
}

export interface ChangePasswordState {
  checkTokenStatus: CheckTokenStatus
  changePasswordStatus: ChangePasswordStatus
  token: string | null
  checkTokenResult: boolean | null
}

export interface CheckTokenFetch {
  type: typeof actionTypes.CHECK_TOKEN_FETCH
  payload: { token }
}

export interface CheckTokenSuccess {
  type: typeof actionTypes.CHECK_TOKEN_SUCCESS
  payload: { result }
}

export interface CheckTokenError {
  type: typeof actionTypes.CHECK_TOKEN_ERROR
  payload: null
}

export interface CheckTokenReset {
  type: typeof actionTypes.CHECK_TOKEN_RESET
  payload: null
}

export interface ChangePasswordFetch {
  type: typeof actionTypes.CHANGE_PASSWORD_FETCH
  payload: { token }
}

export interface ChangePasswordSuccess {
  type: typeof actionTypes.CHANGE_PASSWORD_SUCCESS
  payload: null
}

export interface ChangePasswordExpiredToken {
  type: typeof actionTypes.CHANGE_PASSWORD_EXPIRED_TOKEN
  payload: null
}

export interface ChangePasswordError {
  type: typeof actionTypes.CHANGE_PASSWORD_ERROR
  payload: null
}

export interface ChangePasswordReset {
  type: typeof actionTypes.CHANGE_PASSWORD_RESET
  payload: null
}

export type ChangePasswordActions =
  | CheckTokenFetch
  | CheckTokenSuccess
  | CheckTokenError
  | CheckTokenReset
  | ChangePasswordFetch
  | ChangePasswordSuccess
  | ChangePasswordExpiredToken
  | ChangePasswordError
  | ChangePasswordReset

export const initialState: ChangePasswordState = {
  changePasswordStatus: ChangePasswordStatus.Idle,
  checkTokenStatus: CheckTokenStatus.Idle,
  checkTokenResult: null,
  token: null,
}
